/* eslint-disable camelcase */
import { useEffect } from 'react';
import useUrlQuery from 'Hooks/useUrlQuery';

interface UTMParams {
  [key: string]: string | undefined;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

export function useStoreUtm() {
  const {
    utm_source, utm_medium, utm_campaign, utm_term, utm_content,
  } = useUrlQuery();

  const isPathRegister = window.location.pathname.search('registro') > 0;

  const utmParams: UTMParams = {
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
  };

  useEffect(() => {
    if (!isPathRegister) return;

    const filteredUtmParams = Object.fromEntries(
      Object.entries(utmParams).filter(([, value]) => value !== undefined),
    );

    if (Object.keys(filteredUtmParams).length > 0) {
      localStorage.setItem('UTM', JSON.stringify(filteredUtmParams));
    }
  }, [utm_source, utm_medium, utm_campaign, utm_term, utm_content, isPathRegister]);

  return {};
}
